define('v3/Common/Services/Backend/pupilBackend',[
	'jquery',
	'lodash',
	'BackendBase',
	'v3/Common/Models/enums',
	'v3/Common/Helpers/Sort/Sort.Helper'
], function ($, _, BackendBase, enums, sortableHelper) {
	function PupilBackend () {
		BackendBase.call(this);
	};
	PupilBackend.prototype = $.extend({}, BackendBase.prototype);

	function parsePupilsToPupilModels (pupils) {
		return _.map(pupils, function (pupilArrayOfNames, pupilId) {
			return {
				pupilId: Number(pupilId),
				firstName: pupilArrayOfNames[enums.pupilBackendNames.firstName],
				suffix: pupilArrayOfNames[enums.pupilBackendNames.suffix],
				lastName: pupilArrayOfNames[enums.pupilBackendNames.lastName],
				shortName: pupilArrayOfNames[enums.pupilBackendNames.shortName],
				longName: pupilArrayOfNames[enums.pupilBackendNames.longName],
				pupilFromAnotherClass: pupilArrayOfNames[enums.pupilBackendNames.pupilFromAnotherClass] === 'true',
				actualClassName: pupilArrayOfNames[enums.pupilBackendNames.actualClassName],
				pupilNameForSorting: sortableHelper.prototype.settingsSortingKey() === 'lastNameForSorting'
					? pupilArrayOfNames.slice(0, 3).reverse().join(' ').toLowerCase()
					: pupilArrayOfNames.slice(0, 3).join(' ').toLowerCase()
			};
		});
	};

	$.extend(PupilBackend.prototype, {
		getPupilsLongNamesWithNameForSorting: function () {
			return this._getJsonApi('Pupils/AllInSubjectGroupsInCurrentClass').then(function (pupils) {
				return parsePupilsToPupilModels(pupils);
			});
		},
		getPupilsLongNames: function () {
			return this._getJsonApi('Pupils/AllInSubjectGroupsInCurrentClass');
		},
		getClassPupilAccountSettings: function () {
			return this._getJsonApi('Pupils/ClassPupilAccountSettings');
		},
		getSchoolPasswordSettings: function () {
			return this._getJsonApiWithJwtAuthorization(this._getApiUrl('Pupils/SchoolPasswordSettings'));
		},
		savePupil: function (pupil) {
			return this._postJsonApiWithJwtAuthorization(this._getApiUrl('Pupils/SavePupil/' + pupil.userId), pupil);
		},
		removePupil: function (userId) {
			return this._postApi('Pupils/RemovePupil/' + userId);
		},
		getSubjectGroupPupilNames: function (subjectGroupId) {
			return this._getJsonApi('Pupils/SubjectGroup/' + subjectGroupId);
		},
		getSubjectGroupPupilNamesForSorting: function (subjectGroupId) {
			return this._getJsonApi('Pupils/SubjectGroup/' + subjectGroupId).then(function (pupils) {
				return parsePupilsToPupilModels(pupils);
			});
		},
		getNumberOfPupilsNotInAnySubjectGroupsInClass: function () {
			return this._getJsonApi('Pupils/NumberOfPupilsNotInAnySubjectGroupsInClass');
		},
		checkUniquePupilUserName: function (userId, userName) {
			return this._getJsonApi('Pupils/CheckUniquePupilUserName', { userId: userId, userName: userName });
		},
		checkUniquePupilEmail: function (userId, email) {
			return this._getJsonApi('Pupils/CheckUniquePupilEmail', { userId: userId, email: email });
		},
		getClassPupilsPinCodes: function () {
			return this._getJsonApi('Settings/ClassPupilsPinCodes');
		},
		checkAllowedPupilEmail: function (email) {
			return this._getJsonApi('Pupils/checkAllowedPupilEmail', { email: email });
		}
	});
	return new PupilBackend();
});
